/**
 * @file No photos found component.
 */

import React from 'react';
import PropTypes from 'prop-types';

import ContentWrap from '../global/ContentWrap';
import Button from '../global/Button';
import { getAsset } from '../../util/assets';
import { formatPriceForDisplay } from '../../util/format-money';

const propTypes = {
  album: PropTypes.shape({
    id: PropTypes.string,
  }),
  hasPpaMode: PropTypes.bool,
  entitledPhotosNo: PropTypes.number,
  subscriptionPrice: PropTypes.number,
  children: PropTypes.node,
  onPurchase: PropTypes.func,
};

const NoPhotosFound = ({
  album,
  hasPpaMode,
  entitledPhotosNo,
  subscriptionPrice,
  children,
  onPurchase,
}) => (
  <div className="content-wrap-gray flex-auto">
    <ContentWrap>
      {children}
      <div className="text-center">
        <img src={getAsset('/waldo-magnified.svg')} alt="" className="mb-2" />

        <h3 className="mb-3">
          {entitledPhotosNo > 0
            ? "No new matches yet, but I'm still looking for you!"
            : "No matches yet, but I'm looking for you now!"}
        </h3>

        <p className="mb-0">
          {entitledPhotosNo > 0
            ? "I'll let you know as soon as I find more photos of you!"
            : "I'll let you know as soon as I find photos of you!"}

          {/* TODO: check for folder subscription as well,
          if the user has bought one don't show this or the button */}
          {hasPpaMode && (
            <span className="ml-1">
              Or, go ahead! Buy all your matches below!
            </span>
          )}
        </p>

        {hasPpaMode && (
          <Button
            btnBlock
            onClick={onPurchase}
            to={
              onPurchase
                ? undefined
                : {
                    pathname: `/purchase/album/${album.id}/faces`,
                    state: {
                      forcePurchase: true,
                    },
                  }
            }
            className="text-left pl-3 mt-4"
          >
            Purchase all matches
            <span className="btn-addon">
              ${formatPriceForDisplay(subscriptionPrice)}
            </span>
          </Button>
        )}

        {entitledPhotosNo > 0 && (
          <Button
            btnOutline
            btnBlock
            className="mt-3"
            to={`/view/album/${album.id}`}
          >
            View your purchased photos
          </Button>
        )}
      </div>
    </ContentWrap>
  </div>
);

NoPhotosFound.propTypes = propTypes;

export default NoPhotosFound;
